/* Kinetic Activewear — extras.js
   Quick add, wishlist, cart upsells, load more, header hide,
   back to top, announcement rotation */
(function () {
  'use strict';

  function money(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }
  function refreshDrawerAndOpen() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .then(function () {
        return fetch(window.location.pathname + '?sections=cart-drawer');
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var current = document.getElementById('CartDrawer');
        if (html && current) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var fresh = temp.querySelector('#CartDrawer');
          if (fresh) current.innerHTML = fresh.innerHTML;
          current.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(function () {});
  }
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  /* ---------- quick add / quick view ---------- */
  var qvModal = document.getElementById('QuickViewModal');
  var qvBody = qvModal && qvModal.querySelector('[data-qv-body]');
  var qvProduct = null;

  function qvRender() {
    if (!qvProduct) return;
    var selects = qvBody.querySelectorAll('[data-qv-option]');
    var chosen = [];
    selects.forEach(function (s, i) { chosen[i] = s.value; });
    var variant = qvProduct.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    var priceEl = qvBody.querySelector('[data-qv-price]');
    var btn = qvBody.querySelector('[data-qv-add]');
    if (variant) {
      priceEl.textContent = money(variant.price);
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      btn.setAttribute('data-variant-id', variant.id);
    } else {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = trigger.getAttribute('data-quick-add');
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        // single-variant products go straight to cart
        if (product.variants.length === 1) {
          return addToCart(product.variants[0].id, 1).then(refreshDrawerAndOpen);
        }
        if (!qvModal || !qvBody) return;
        qvProduct = product;
        var html = '<div class="quickview__body"><div class="quickview__image">' +
          (product.featured_image ? '<img src="' + esc(product.featured_image) + '" alt="">' : '') +
          '</div><div>' +
          '<h2 class="quickview__title">' + esc(product.title) + '</h2>' +
          '<p class="quickview__price" data-qv-price>' + money(product.price) + '</p>';
        product.options.forEach(function (opt, i) {
          html += '<div class="option-group"><label class="option-group__label" for="QvOpt' + i + '">' + esc(opt.name) + '</label>' +
            '<select id="QvOpt' + i + '" data-qv-option class="localization-select" style="border-color:var(--color-border);color:var(--color-text);width:100%;">';
          opt.values.forEach(function (v) {
            html += '<option value="' + esc(v) + '">' + esc(v) + '</option>';
          });
          html += '</select></div>';
        });
        html += '<button class="btn btn--full" data-qv-add>Add to cart</button>' +
          '<a class="quickview__full-link" href="' + esc(product.url) + '">View full details</a>' +
          '</div></div>';
        qvBody.innerHTML = html;
        qvRender();
        qvModal.classList.add('is-open');
      })
      .catch(function () {});
  });

  if (qvBody) {
    qvBody.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-qv-option')) qvRender();
    });
    qvBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qv-add]');
      if (!btn) return;
      var id = parseInt(btn.getAttribute('data-variant-id') || (qvProduct && qvProduct.variants[0].id), 10);
      if (!id) return;
      btn.disabled = true;
      addToCart(id, 1)
        .then(function () {
          qvModal.classList.remove('is-open');
          return refreshDrawerAndOpen();
        })
        .catch(function () { btn.disabled = false; });
    });
  }

  /* ---------- wishlist ---------- */
  var WL_KEY = 'kinetic:wishlist';
  function readWL() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
  }
  function writeWL(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
    updateWLCount();
    syncHearts();
  }
  function updateWLCount() {
    var n = readWL().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
    });
  }
  function syncHearts() {
    var list = readWL();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var list = readWL();
    var idx = list.indexOf(handle);
    if (idx === -1) list.unshift(handle); else list.splice(idx, 1);
    writeWL(list.slice(0, 60));
  });
  updateWLCount();
  syncHearts();

  // wishlist page grid
  document.querySelectorAll('[data-wishlist-page]').forEach(function (root) {
    var grid = root.querySelector('[data-wl-grid]');
    var empty = root.querySelector('[data-wl-empty]');
    var handles = readWL();
    if (!handles.length) {
      if (empty) empty.classList.remove('hidden');
      return;
    }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) {
        if (!r.ok) throw new Error('gone');
        return r.json();
      }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        if (empty) empty.classList.remove('hidden');
        return;
      }
      grid.innerHTML = products.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + esc(p.featured_image) + '" alt="" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">'
          : '';
        return '<div class="product-card"><a href="' + esc(p.url) + '">' +
          '<div class="product-card__media">' + img +
          '<button class="wishlist-toggle is-active" data-wishlist-toggle="' + esc(p.handle) + '" aria-label="Remove from wishlist">' +
          '<svg viewBox="0 0 24 24"><path d="M12 20.5C7 16.5 3.5 13.2 3.5 9.4 3.5 6.9 5.4 5 7.9 5c1.6 0 3.1.8 4.1 2.2C13 5.8 14.5 5 16.1 5c2.5 0 4.4 1.9 4.4 4.4 0 3.8-3.5 7.1-8.5 11.1z"/></svg></button>' +
          '<button class="quick-add" data-quick-add="' + esc(p.handle) + '">Quick add</button>' +
          '</div>' +
          '<div class="product-card__info">' +
          '<h3 class="product-card__title">' + esc(p.title) + '</h3>' +
          '<div class="product-card__price"><span class="price">' + money(p.price) + '</span></div>' +
          '</div></a></div>';
      }).join('');
      syncHearts();
    });
  });

  /* ---------- cart upsell add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-upsell-add'), 10);
    btn.disabled = true;
    addToCart(id, 1).then(refreshDrawerAndOpen).catch(function () { btn.disabled = false; });
  });

  /* ---------- load more (collections) ---------- */
  var loadMore = document.querySelector('[data-load-more]');
  if (loadMore) {
    loadMore.addEventListener('click', function () {
      var nextUrl = loadMore.getAttribute('data-next-url');
      if (!nextUrl) return;
      loadMore.disabled = true;
      loadMore.textContent = 'Loading…';
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var grid = document.querySelector('.card-grid');
          var newGrid = doc.querySelector('.card-grid');
          if (grid && newGrid) {
            while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
          }
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn && newBtn.getAttribute('data-next-url')) {
            loadMore.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            loadMore.disabled = false;
            loadMore.textContent = loadMore.getAttribute('data-label') || 'Load more';
          } else {
            loadMore.closest('.load-more-wrap').style.display = 'none';
          }
          syncHearts();
        })
        .catch(function () {
          loadMore.disabled = false;
          loadMore.textContent = loadMore.getAttribute('data-label') || 'Load more';
        });
    });
  }

  /* ---------- header hide on scroll ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 260 && y > lastY + 4) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 260) header.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  }

  /* ---------- back to top ---------- */
  var backTop = document.getElementById('BackToTop');
  if (backTop) {
    window.addEventListener('scroll', function () {
      backTop.classList.toggle('is-visible', window.scrollY > 900);
    }, { passive: true });
    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- announcement rotation (mobile) ---------- */
  var bar = document.querySelector('.announcement-bar');
  if (bar) {
    var items = bar.querySelectorAll('.announcement-bar__item');
    if (items.length > 1 && window.matchMedia('(max-width: 749px)').matches) {
      bar.setAttribute('data-rotating', '');
      var current = 0;
      items[0].classList.add('is-active');
      setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, 4000);
    }
  }
})();
